
import { useState } from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Plus, MapPin } from "lucide-react";
import { CityForm } from "../admin/CityForm";
import { CityList } from "../admin/city-management/CityList";
import { CityStats } from "../admin/city-management/CityStats";
import { useCityData } from "../admin/city-management/useCityData";
import { useAuth } from "@/hooks/useAuth";

export function OrganizationCityManagement() {
  const { profile } = useAuth();
  const { cities, organizations, loading, fetchCities, handleDelete } = useCityData();
  const [isCreateDialogOpen, setIsCreateDialogOpen] = useState(false);

  // Filter cities to show organization-specific and global cities
  const organizationCities = cities.filter(city => 
    city.organization_id === profile?.organization_id || city.organization_id === null
  );

  const handleCreateSuccess = () => {
    setIsCreateDialogOpen(false);
    fetchCities();
  };

  const handleEditSuccess = () => {
    fetchCities();
  };

  if (loading) {
    return (
      <Card>
        <CardHeader style={{ backgroundColor: 'orange' }}>
          <CardTitle className="flex items-center gap-2">
            <MapPin className="h-5 w-5" />
            City Management
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-center py-4">Loading cities...</div>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader style={{ backgroundColor: 'orange' }}>
        <CardTitle className="flex items-center gap-2">
          <MapPin className="h-5 w-5" />
          City Management
        </CardTitle>
        <CardDescription>
          Manage cities for your organization's flight destinations
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="flex justify-between items-center mb-4">
          <CityStats totalCities={organizationCities.length} />
          <Dialog open={isCreateDialogOpen} onOpenChange={setIsCreateDialogOpen}>
            <DialogTrigger asChild>
              <Button>
                <Plus className="h-4 w-4 mr-2" />
                Add City
              </Button>
            </DialogTrigger>
            <DialogContent>
              <DialogHeader>
                <DialogTitle>Create New City</DialogTitle>
              </DialogHeader>
              <CityForm 
                organizations={organizations.filter(org => org.id === profile?.organization_id)}
                onSubmit={handleCreateSuccess}
              />
            </DialogContent>
          </Dialog>
        </div>

        <CityList
          cities={organizationCities}
          organizations={organizations}
          onEdit={handleEditSuccess}
          onDelete={handleDelete}
        />
      </CardContent>
    </Card>
  );
}
